import { Typography } from '@mui/material'
import styles from './weddingCard.module.scss'
import ButtonCustom from '../button/ButtonCustom'

const WeddingCard = ({ heading, children, style, actionLabel, handleAction }) => {
	return (
		<div className={styles.weddingCard} style={style}>
			{heading && (
				<div className={styles.cardHeader}>
					<Typography variant="h3" className={styles.cardTitle}>
						{heading}
					</Typography>
					{actionLabel && (
						<ButtonCustom
                            variant="outlined"
                            size="lg"
                            onClick={handleAction}
                        >
							{actionLabel}
						</ButtonCustom>
					)}
				</div>
			)}
			<div className={styles.cardBody}>{children}</div>
		</div>
	)
}

export default WeddingCard
